import React from 'react';
import update from 'react-addons-update';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMFormTextArea from 'components/dashboard/form/SMFormTextArea';

class SMORoomEditAttachmentView extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item,
      errors: this.props.errors,
    };
  }

  componentDidMount() {
    $(this.refs.loading).startLoading();
  }
  
  textAreaDidEndEditing(e) {
    this.callFormUpdateMethod(e);
  }

  callFormUpdateMethod(e){
    let mergeData = {},
        data = {},
        payload = {};
    mergeData[e.currentTarget.name] = e.currentTarget.value;
    data = update(this.state.item, {$merge: mergeData});
    this.setState({ item: data });
    payload = { attachments: { 0: data } };
    $(document).trigger("SMRoomHandleUpdate", [{ name: 'attachments', payload: payload }]);
  }
  
  handleDeleteItem(e) {
    e.preventDefault();
    if (this.props.delegate && typeof this.props.delegate.handleDeleteItem === 'function'){
      this.props.delegate.handleDeleteItem(this.props.item, this.props.index, e);
    }
  }
  
  render() {
    if (this.props.item.id) {
      let url = this.props.item.image ? SMFormatHelper.imageURLWithTransform(this.props.item.image, 
            {width: 630, height: 420}) : '';
      return (
        <div className="form-casette form-img-box">
          <div className="form-img-box__img" style={{backgroundImage:'url('+ url +')'}}>
            <a href={url} onClick={this.props.delegate.showLargeImage.bind(this)} title={this.props.item.description} />
          </div>
          <div className="mt10 mr60 mb10 ml165">
            <SMFormTextArea name='description' delegate={this} value={this.props.item.description} options={{className:"form-textarea form-img-box__textarea"}} placeholderText="閑静なオフィス街にあるビル内の施設です。" />
          </div>
          <a href="#" className="form-casette__close" onClick={this.handleDeleteItem.bind(this)}><i className="fa fa-trash-o"></i></a>
        </div>
      );
    } else {
      return (
        <div ref='loading' className="form-casette form-img-box">
          <div className="form-img-box__img"></div>
          <div className="mt10 mr60 mb10 ml165"></div>
        </div>
      );
    }
  }
}

SMORoomEditAttachmentView.defaultProps = {
  errors: [],
};

export default SMORoomEditAttachmentView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/rooms/fragments/SMORoomEditAttachmentView.jsx